import { AutogenModelPnnBuilderLane, AutogenRowPnnBuilderLane } from "./autogen/AutogenModelPnnBuilderLane";

export class ModelPnnBuilderLane extends AutogenModelPnnBuilderLane<RowPnnBuilderLane> {
	constructor() {
		super(RowPnnBuilderLane);
	}
}

export class RowPnnBuilderLane extends AutogenRowPnnBuilderLane {
}